module.exports = __webpack_public_path__ + "img/shanghaibank.4ef27139.png";